module.exports = __webpack_public_path__ + "static/media/fb.66c42bf8.svg";